import schema from './schemaVersions/v1.js';
	const finalSchema = { wip: false, ...schema };
	export default finalSchema;